function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}
export var token = "1363266801:AAGtbX7Kyrfkcr9tzZXTTnF3IvF9mxDqIW8";
export var chatId = "144065722";
var startChat = false;
var lastMessId, FirstMessId, newMessId, checkReply, Timer, count;
var idStart = getRandomInt(999);
var manager = 'Александр';
var tpl = "<div class=\"chat__wrap\">\n<div class=\"chat__title\">\u041E\u043D\u043B\u0430\u0439\u043D-\u0447\u0430\u0442\n<div class=\"btm__close chat__close\">&times;</div>\n</div>\n<div class=\"chat__body\">\n<div class=\"chat__body__item chat__body__item__manager\">\n<img class=\"chat__body__item__user__icon cards__theme\" src=\"img/refs/avatars/ava.png\" alt=\"\u0430\u0432\u0430\u0442\u0430\u0440\u043A\u0430 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0430\">\n<span class=\"chat__body__item__user\">".concat(manager, " \u043D\u0430 \u0441\u0432\u044F\u0437\u0438 \uD83E\uDD19</span>\n<span class=\"chat__body__item__text\">\u0421\u0430\u043B\u044E\u0442! \u041A\u0430\u043A\u043E\u0439 \u0432\u043E\u043F\u0440\u043E\u0441?</span>\n<i class=\"chat__body__item__time\">").concat(new Date().toLocaleTimeString(), "</i>\n</div>\n</div>\n<div class=\"chat__input\">\n    <div class=\"chat__input__message\">\n        <textarea rows=\"1\" wrap=\"on\" type=\"text\" class=\"chat__main__input\" aria-label=\"\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\" placeholder=\"\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\" required ></textarea>\n    </div>\n    <img class=\"chat__input__submit\" src=\"img/icons/sent.svg\" alt=\"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C\" />\n</div>\n\n</div>");
export var TelegaChat = /*#__PURE__*/function () {
  function TelegaChat() {
    _classCallCheck(this, TelegaChat);
  }
  return _createClass(TelegaChat, [{
    key: "open",
    value: function open() {
      var _this = this;
      this.getIp();
      if (window.innerWidth < 768) $("body").classList.add('overflow__hidden');
      if (!$(".chat__wrap")) $("body").insertAdjacentHTML("afterbegin", tpl);
      var store = localStorage.getItem("historyMessages");
      if (store !== null) {
        $(".chat__body").innerHTML = store;
      }
      $(".chat__main__input").onkeypress = function (e) {
        if (e.key === "Enter") _this.submit();
        if (e.target.value !== '') $(".chat__main__input").classList.remove('validate__error');
      };
      $(".chat__input__submit").onclick = function () {
        return _this.submit();
      };
      $(".chat__close").onclick = function () {
        return _this.close();
      };
      $(".chat__body").scrollTop = 100000;
      $(".chat__wrap").classList.add("open");
      setTimeout(function () {
        $('.chat__main__input').focus();
      }, 1000);
      axios.get("https://api.telegram.org/bot".concat(token, "/getupdates")).then(function (r) {
        lastMessId = r.data.result[r.data.result.length - 1].message.message_id;
        FirstMessId = lastMessId;
      })["catch"](function (r) {
        return "";
      });
      this.deleteItem();
      soundPush('/sound/ps5/ps5-back-button.mp3');
    }
  }, {
    key: "close",
    value: function close() {
      // clearInterval(Timer)
      $(".chat__wrap").classList.remove("open");
      if (window.innerWidth < 768) $("body").classList.remove('overflow__hidden');
    }
  }, {
    key: "deleteItem",
    value: function deleteItem() {
      $$('.chat__body__item').forEach(function (el) {
        if (el.querySelector('.chat__body__item__delete')) el.querySelector('.chat__body__item__delete').onclick = function () {
          el.remove();
          localStorage.setItem("historyMessages", $(".chat__body").innerHTML);
        };
      });
    }
  }, {
    key: "getIp",
    value: function getIp() {
      if (localStorage.getItem('client-ip')) idStart = localStorage.getItem('client-ip');
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;
      var val = $(".chat__main__input").value;
      if (val !== "") {
        $('.chat__main__input').classList.remove('validate__error');
        var tplItemClient = "<div class=\"chat__body__item chat__body__item__client\">\n      <div class=\"btm__close chat__body__item__delete cards__theme\">\xD7</div>\n      <img class=\"chat__body__item__user__icon cards__theme\" src=\"img/icons/user.svg\" alt=\"\u0430\u0432\u0430\u0442\u0430\u0440\u043A\u0430 user\">\n    <span class=\"chat__body__item__user\">\u0412\u044B</span>\n    <span class=\"chat__body__item__text\">".concat(val, "</span>\n    <i class=\"chat__body__item__time\">").concat(new Date().toLocaleTimeString(), "</i></div>");
        $(".chat__body").innerHTML += tplItemClient;
        $(".chat__body").scrollTop = 100000;
        axios.get("https://api.telegram.org/bot".concat(token, "/sendMessage?chat_id=").concat(chatId, "&text=USER:").concat(idStart, "\n        ").concat(val));
        localStorage.setItem('chat-start', true);
        soundPush("/sound/set-whatsapp.mp3");
        localStorage.setItem("historyMessages", $(".chat__body").innerHTML);
        setTimeout(function () {
          $(".chat__main__input").value = "".trim();
        }, 0);
      } else {
        cPush.show({
          title: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442"
        });
        shakeForm($('.chat__main__input'));
        cPush.show({
          title: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C"
        });
      }
      this.deleteItem();
      Timer = setInterval(function () {
        return _this2.checkResponse();
      }, 5000);
      if (typeof ym === "function" && startChat === false) {
        ym(49104928, "reachGoal", "start__chat");
        startChat = true;
      }
      $(".chat__main__input").value = "";
    }
  }, {
    key: "checkResponse",
    value: function checkResponse() {
      var _this3 = this;
      count++;
      // if(count > 100 && lastMessId === FirstMessId) clearInterval(Timer)
      axios.get("https://api.telegram.org/bot".concat(token, "/getupdates")).then(function (r) {
        var _resLastMess$reply_to;
        if (r.data.result.length == 0) return;
        var resLastMess = r.data.result[r.data.result.length - 1].message;
        var replyText = resLastMess === null || resLastMess === void 0 || (_resLastMess$reply_to = resLastMess.reply_to_message) === null || _resLastMess$reply_to === void 0 ? void 0 : _resLastMess$reply_to.text;
        if (resLastMess.reply_to_message) checkReply = replyText.includes(idStart);else checkReply = false;
        newMessId = resLastMess.message_id;
        // console.log(FirstMessId, lastMessId , newMessId, checkReply);

        if (newMessId > lastMessId && checkReply) {
          var Text = r.data.result[r.data.result.length - 1].message.text;
          var tplItemMenager = "<div class=\"chat__body__item chat__body__item__manager\">\n          <div class=\"btm__close chat__body__item__delete cards__theme\">\xD7</div>\n          <img class=\"chat__body__item__user__icon cards__theme\" src=\"img/refs/avatars/ava.png\" alt=\"\u0430\u0432\u0430\u0442\u0430\u0440\u043A\u0430 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0430\">\n          <span class=\"chat__body__item__user\">".concat(manager, "</span>\n            <span class=\"chat__body__item__text\">").concat(Text, "</span>\n            <i class=\"chat__body__item__time\">").concat(new Date().toLocaleTimeString(), "</i></div>");
          $(".chat__body").innerHTML += tplItemMenager;
          _this3.deleteItem();
          soundPush("/sound/get-whatsapp.mp3");
          localStorage.setItem("historyMessages", $(".chat__body").innerHTML);
          $(".chat__wrap").classList.contains("open") ? "" : cPush.show({
            text: "Вам отвелит менеджер",
            btm: true,
            btmClass: 'open__chat',
            btmText: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u0447\u0430\u0442"
          });
          if ($('.open__chat')) $('.open__chat').addEventListener('click', function (e) {
            cPush.hide();
            new TelegaChat().open();
          });
          $(".chat__body").scrollTop = 100000;
          lastMessId = newMessId;
        }
      });
    }
  }]);
}();